import React from 'react';
import { ContactUsPageTypes } from '../ContactUsPageTypes';
import { weakKey } from '../../../utilities/weakKey';
import { IconsHelper } from '../helpers/IconsHelper';
import { useVariant } from '../hooks/VariantContext';

type TSocialMediaIconsComponent = {
  allIconsColor?: string;
  iconsData: ContactUsPageTypes.TSocialIcons;
};

export const ContactUsSocialMediaIcons = ({
  allIconsColor,
  iconsData,
}: TSocialMediaIconsComponent) => {
  const variant = useVariant();

  const getSocialMediaIcons = (socialIcons: any) => {
    let iconsArray: any[] = [];
    for (let socialIcon in socialIcons) {
      const iconsData = socialIcons[socialIcon];
      iconsData.forEach((icons: ContactUsPageTypes.TNewIcon) => {
        icons.iconsUrl &&
          iconsArray.push(
            <a
              className="socialIcon pr-5"
              href={icons.iconsUrl}
              key={weakKey(icons)}
              target="_blank"
            >
              {icons.icon && (
                <IconsHelper
                  allIconsColor={allIconsColor}
                  iconsConfig={icons.icon}
                />
              )}
            </a>
          );
      });
    }
    return iconsArray;
  };

  return (
    <div
      className={`iconsContainer ${variant === 'newContactUsDarkTheme' &&
        'pt-5'}`}
    >
      {getSocialMediaIcons(iconsData)}
    </div>
  );
};
